if($('.external-review-swipe').length){
  hp.swipers = hp.swipers || {};
  var external_review_swipe = 
  {
    initialized: false
  };

  external_review_swipe.init = function(){
    if (window.innerWidth >= 768){
      var twitterModuleProps = {
        direction: 'vertical',
        autoplay: {
          delay: $(".twitter-swiper-clearfix").data("delay") ? parseInt($(".twitter-swiper-clearfix").data("delay") ): 3000,
          disableOnInteraction: false
      },
      speed: 1000,
        // for navigation
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        // for pagination
        pagination: {
        el: '.card-module-pagination',
        // type: 'progressbar',
        // type: 'fraction',
        clickable: true,        
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' +'0'+ (index + 1) + '</span>';
          },
        },
        spaceBetween: 500,
        // slidesPerView: 1.3,
        slidesPerView: 'auto',
        centeredSlides: true,
        // effect: 'fade',
        slidesPerGroup:1,
        loop: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
        // 1024: {
        //     slidesPerView: 1,
        //     spaceBetween: 0,
        // },
        //  768: {
        //      slidesPerView: 1,
        //      spaceBetween: 0,
        //  },
        // 640: {
        //     slidesPerView: 1,
        //     spaceBetween: 0,
        // },
        // 320: {
        //     slidesPerView: 1,
        //     spaceBetween: 0,
        // }
        }
    }}
    else {
      var twitterModuleProps = {
        autoplay: {
          delay: $(".twitter-swiper-clearfix").data("delay") ? parseInt($(".twitter-swiper-clearfix").data("delay") ): 3000,
          disableOnInteraction: false
      },
      speed: 1000,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
        pagination: {
          el: '.card-module-pagination',
          type: 'bullets',
          clickable: true,
        },
        lazy: false,
        slidesPerView:'auto',
        slidesPerGroup:1,
        spaceBetween: 50,
        loop: true,
        breakpoints: {
          // 1024: {
          //     slidesPerView: 1,
          //     spaceBetween: 0,
          // },
          //  768: {
          //      slidesPerView: 1,
          //      spaceBetween: 0,
          //  },
          // 420: {
          //    slidesPerView: 1,
          //    spaceBetween: 50,
          // },
          // 320: {
          //     slidesPerView: 1,
          //     spaceBetween: 0,
          // }
          }
        }
      }
      
      var twitterModuleMethods = {
        _this: this,
        resizeHandler: true,
        a11ySwiper: true,
        swiperEvents: [/* */
        {
          eventName: "slideChangeTransitionStart",
          eventMethod: function (_this) {
            window.mySlide = _this.slides[_this.activeIndex];
            $(_this.slides).css({'opacity':'0'});
            window.mySlide.style.opacity = '1';
            window.mySlide.childNodes[1].style.opacity = '0';
            window.mySlide.style.top = '0';
          }
        },{
          eventName: "slideChangeTransitionEnd",
          eventMethod: function (_this) {
            inner = window.mySlide.childNodes[9];
            text = window.mySlide.childNodes[7];
            title = text.childNodes[1];
            inner.style.opacity = '0';
            text.style.opacity = '0';
            animateMe(_this.slides[_this.activeIndex].childNodes[1], null)
            window.twitterModulet2 = setTimeout(function(){
              _this.slides[_this.activeIndex].style.opacity = '0';
            },twitterModuleProps.autoplay.delay*0.96);
            window.twitterModulet3 = setTimeout(function(){
              animateMe(text, title);
              window.mySlide.style.top = '-100%';
              // window.mySlide.style.opacity = '1';
              $(inner).animate({"opacity": "1"}, 1000);
            },twitterModuleProps.autoplay.delay/2);
            // if(window.mySlide){window.mySlide.style.opacity = 1;window.mySlide.style.top = 0;};
          }
        }
        ]
        // mySwiper.slideNext(speed, runCallbacks);
      }

      external_review_swipe.instances = hp.swiperInstance('.external-review-swipe', twitterModuleProps, twitterModuleMethods);
      window.twitterModule=external_review_swipe.instances;
      if(typeof external_review_swipe.instances.slideNext !== 'undefined'){
        external_review_swipe.instances.slideNext();
      /* twitter text typing animation start */
        external_review_swipe.instances.on('slideChange', function(){
          window.clearInterval(window.twitterModulet2);
          window.clearInterval(window.twitterModulet3);
        });
      }
    }//END init


    function animateMe(div, title){
      var $div = $(div),
          $title = $(".tablet-width-clearfix h2", $div),
          txt = $title.text(),
          str = '',
          ray = [],
          ind = 0,
          int;

      // check if text is too large for container.
      if($title.height()>160){
        // if it is, truncate text to last full word that will fit,
        while($title.height()>160){
          txt = txt.substr(0,txt.lastIndexOf(' '));
          $title.text(txt);
        }
        // then remove last word and replace with ellipsis
        txt = txt.substr(0,txt.lastIndexOf(' '))+'...';
      }
      div.style.opacity = '1';
      // make div visible and clear the text
      $div.css('visibility','visible');
      $title.text('');
      // turn the words in txt into and array, set txt to empty string
      txt = txt.trim().replace(/\r?\n|\r/g, "");
      ray = txt.split(" ").filter(function(item){return item});
      txt = '';
      
      //set interval to add one word during each iteration untill all the words are shown
      int = setInterval(function(){
        if(ind<ray.length){
          txt += ray[ind]+' ';
          $title.text(txt);
          ind++;
        }else{
          clearInterval(int);
          //int=null;
        }
      },50) 
    }

    hp.swipers.external_review_swipe = external_review_swipe;
}
